import { Injectable } from '@angular/core';

/**
 * Lets nested, dynamically rendered widgets expose unsaved work to route
 * guards. Registrations are scoped to the widget lifetime and removed when the
 * widget is destroyed.
 */
@Injectable({ providedIn: 'root' })
export class PendingChangesService {
  private readonly checks = new Map<symbol, () => boolean>();

  register(check: () => boolean): () => void {
    const key = Symbol('pending-changes');
    this.checks.set(key, check);
    return () => this.checks.delete(key);
  }

  hasPendingChanges(): boolean {
    return Array.from(this.checks.values()).some((check) => check());
  }
}
